import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

const $ = require('jquery')

window.$ = $

createApp(App)
  .use(store)
  .use(router)
  .directive('select2', {
    beforeMount(el, binding, vnode) {
      $(el)
        .select2()
        .on('select2:select', (e) => {
          el.dispatchEvent(new Event('change', { target: e.target }))
        })
    },
    updated(el) {
      $(el).trigger('change')
    },
  })
  .mount('#app')
